import React from 'react';
import MyAttendance from '../../profile/MyAttendance';

const AttendanceDashboard = () => {
  return <MyAttendance />;
};

export default AttendanceDashboard;
